import { render, staticRenderFns } from "./CardFree.vue?vue&type=template&id=2a037a36&scoped=true&"
import script from "./CardFree.vue?vue&type=script&lang=js&"
export * from "./CardFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a037a36",
  null
  
)

export default component.exports